// Shared log category configurations used by QuickLog and LogDetail

export const CATEGORIES = [
  {
    key: 'illness',
    label: 'Illness',
    icon: '\u{1F912}',
    color: '#b8860b',
    colorLight: '#fdf6e3',
    colorDark: '#7a5a00',
    colorBorder: '#e8d5a0',
    pills: [
      { value: 'covid_19', label: 'COVID-19', icon: '\u{1F9A0}' },
      { value: 'flu_a', label: 'Flu A', icon: '\u{1F927}' },
      { value: 'flu_b', label: 'Flu B', icon: '\u{1F927}' },
      { value: 'rsv', label: 'RSV', icon: '\u{1FAC1}' },
      { value: 'pneumonia', label: 'Pneumonia', icon: '\u{1F912}' },
      { value: 'other', label: 'Other', icon: '\u{1F48A}' },
    ],
  },
  {
    key: 'condition',
    label: 'Condition',
    icon: '\u{1FAC0}',
    color: '#1a7a6d',
    colorLight: '#e6f5f2',
    colorDark: '#145f55',
    colorBorder: '#a8d8cf',
    pills: [
      { value: 'heart_disease', label: 'Heart Disease', icon: '\u{1FAC0}' },
      { value: 'diabetes', label: 'Diabetes', icon: '\u{1FA78}' },
      { value: 'alzheimers', label: "Alzheimer's", icon: '\u{1F9E0}' },
      { value: 'cancer', label: 'Cancer', icon: '\u{1F397}\uFE0F' },
      { value: 'high_blood_pressure', label: 'High BP', icon: '\u{1FA7A}' },
      { value: 'other', label: 'Other', icon: '\u{1F48A}' },
    ],
  },
  {
    key: 'vehicle',
    label: 'Vehicle',
    icon: '\u{1F697}',
    color: '#4a6178',
    colorLight: '#eaf0f6',
    colorDark: '#334455',
    colorBorder: '#b0c4d8',
    pills: [
      { value: 'first_car', label: 'First Car', icon: '\u{1F511}' },
      { value: 'bought', label: 'Bought', icon: '\u{1F3F7}\uFE0F' },
      { value: 'accident', label: 'Accident', icon: '\u{1F4A5}' },
      { value: 'sold', label: 'Sold', icon: '\u{1F44B}' },
      { value: 'just_logging', label: 'Just Logging', icon: '\u{1F4AD}' },
    ],
  },
];

export const ILLNESS_SYMPTOMS = [
  { value: 'fever', label: 'Fever', icon: '\u{1F321}\uFE0F' },
  { value: 'cough', label: 'Cough', icon: '\u{1F637}' },
  { value: 'sore_throat', label: 'Sore Throat', icon: '\u{1F615}' },
  { value: 'runny_nose', label: 'Runny Nose', icon: '\u{1F927}' },
  { value: 'body_aches', label: 'Body Aches', icon: '\u{1F625}' },
  { value: 'headache', label: 'Headache', icon: '\u{1F915}' },
  { value: 'fatigue', label: 'Fatigue', icon: '\u{1F634}' },
  { value: 'nausea', label: 'Nausea', icon: '\u{1F922}' },
  { value: 'shortness_of_breath', label: 'Shortness of Breath', icon: '\u{1FAC1}' },
  { value: 'loss_of_taste_smell', label: 'Loss of Taste/Smell', icon: '\u{1F443}' },
  { value: 'diarrhea', label: 'Diarrhea', icon: '\u{1F4A9}' },
  { value: 'chills', label: 'Chills', icon: '\u{1F976}' },
];

// Map category key to story type for "promote to story" feature
export const CATEGORY_TO_STORY_TYPE = {
  condition: 'health',
  illness: 'health',
  vehicle: 'personal_experience',
};
